import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Button, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import {
  MailOutlined,
  MessageOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const getTimerDuration = (resendCount) => {
  if (resendCount < 5) return 60; // 1 menit
  if (resendCount < 10) return 120; // 2 menit
  if (resendCount < 20) return 240; // 4 menit
  if (resendCount < 30) return 480; // 8 menit
  if (resendCount < 40) return 960; // 16 menit
  if (resendCount < 50) return 1920; // 32 menit
  return 3840; // 64 menit (jika >= 50)
};

const CHANNELS = [
  { key: "email", label: "Email", icon: <MailOutlined /> },
  { key: "wa", label: "WhatsApp", icon: <WhatsAppOutlined /> },
  { key: "sms", label: "SMS", icon: <MessageOutlined /> },
];

const ResendOTP = ({
  onResend,
  hideDescription = false,
  canResendWithChannel = false,
  loading,
}) => {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(60); // Default 1 menit
  const [resendCount, setResendCount] = useState(0);
  const [selectedChannel, setSelectedChannel] = useState("");

  // Update countdown ketika resendCount berubah
  useEffect(() => {
    const newDuration = getTimerDuration(resendCount);
    setCountdown(newDuration);
  }, [resendCount]);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);

  const handleResend = useCallback(() => {
    onResend({
      callback: () => {
        if (canResendWithChannel) {
          setResendCount((prevCount) => prevCount + 1);
        } else {
          // Untuk kasus tanpa channel, tetap gunakan 1 menit
          setCountdown(60);
        }
      },
    });
  }, [canResendWithChannel, onResend]);

  const handleResendWithChannel = useCallback(
    (channel) => {
      setSelectedChannel(channel);
      onResend({
        via: channel,
        callback: () => {
          setResendCount((prevCount) => prevCount + 1);
          // Timer akan diupdate otomatis oleh useEffect di atas
        },
      });
    },
    [onResend]
  );

  const renderResendGeneral = useMemo(() => {
    if (canResendWithChannel && resendCount > 0) {
      return null;
    }

    return (
      <Button
        size="small"
        type="link"
        onClick={handleResend}
        loading={loading}
        disabled={countdown > 0 || loading}
      >
        {countdown > 0
          ? `${t("users.resend_code")} (${countdown}s)`
          : t("users.resend_code")}
      </Button>
    );
  }, [canResendWithChannel, countdown, t, handleResend, loading, resendCount]);

  return (
    <Space>
      {!hideDescription && <Text>{t("users.not_received_otp_code")}</Text>}
      {canResendWithChannel ? (
        // resendCount > 0 ? (
        <Space direction="vertical" style={{ marginTop: 8, width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <Text type="secondary">
              {`${t("users.resend_code_by")} ${
                countdown > 0 ? `(${countdown}s)` : ""
              }`}
            </Text>
          </div>
          <div style={{ textAlign: "center" }}>
            <Space>
              {CHANNELS.map((channel) => (
                <Button
                  key={channel.key}
                  onClick={() => handleResendWithChannel(channel.key)}
                  loading={selectedChannel === channel.key && loading}
                  disabled={countdown > 0 || loading}
                  icon={channel.icon}
                >
                  {channel.label}
                </Button>
              ))}
            </Space>
          </div>
        </Space>
      ) : (
        // )
        // : (
        //   <>{renderResendGeneral}</>
        // )
        <>{renderResendGeneral}</>
      )}
    </Space>
  );
};

export default ResendOTP;
